import { api, postUrl } from "./base";

const postForm = async (formId: string, data: any, pin?: string) => {
  const url = postUrl(formId);
  const headers = pin ? { "X-Form-AccessCode": pin } : undefined;
  const result = await api.post(
    url,
    { response: JSON.stringify(data) },
    { headers }
  );
  return result.data;
};

const getForm = async (formId: string, pin?: string): Promise<any> => {
  if (pin) {
    return api.get<any>(formId, {
      headers: { "X-Form-AccessCode": pin }
    });
  }
  return api.get<any>(formId);
};

const getFormFieldData = async (
  formId: string,
  fieldId: string
): Promise<any> => {
  return api.get(`${formId},${fieldId}`);
};

interface DocumentDownloadData {
  blobUrl: string;
  pollPeriodSeconds: number;
  timeOutPeriodSeconds: number;
}

const getDocumentDownloadData = async (
  formId: string,
  pin?: string
): Promise<DocumentDownloadData> => {
  const headers = pin ? { "X-Form-AccessCode": pin } : undefined;
  const result = await api.post(`${formId}/downloadInfo`, undefined, {
    headers
  });
  return result.data;
};

export { getForm, postForm, getFormFieldData, getDocumentDownloadData };
export type { DocumentDownloadData };
